/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Grid, Stack, useMediaQuery, Box, IconButton, Divider } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { closeDetailsDialog } from "../../../store/reducers/admission.slice";
import { cardPatientAndChartData } from "../../../services/admission.service";
import _ from "lodash";
import CardDetailChart from "../../../components/shared/chart-dialog-common/chart-tab/CardDetailChart";
import {
	chartFilterPermission,
	chartGroupBy,
	chartsData,
	dayDifferent,
	getAdmissionFieldNames,
	isUpdateDefaultFilter,
} from "../../../utilis/charts-common";
import { CHART_FILTER_DAY_OF, CUSTOM_TAB_TYPE, DASHBOARD_FILTER_TYPE, FILTER_TYPES } from "../../../types/common.type";
import { HOSPITAL_CARDS_TYPE } from "../../../types/hospital.type";
import { CHART_POINT_TYPE, CHART_TAB_BUTTON } from "../../../types/chart-dialog.type";
import ChartDialogLeftSidebar from "../../../components/shared/chart-dialog-common/ChartDialogLeftSidebar";
import ChartDetailsTab from "../../../components/shared/chart-dialog-common/ChartDetailsTab";
import ChartTabLoader from "../../../components/shared/chart-dialog-common/ChartTabLoader";
import ChartDialogContainer from "../../../components/shared/chart-dialog-common/ChartDialogContainer";
import ChartTableList from "../../../components/shared/chart-dialog-common/chart-table/ChartTableList";
import { DEFAULT_CHART_DATA, DEFAULT_CHART_FILTER } from "../../../data/common.data";
import { ADMISSION_CARDS_TYPE } from "../../../types/admission.type";
import ChartBuildingList from "../../../components/shared/chart-dialog-common/chart-building/ChartBuildingList";
import { getAccountQuestions } from "../../../services/api/user.api";
import { getChartFacilityPercentageBy, patientDataOrderBy, processCustomChartFilters } from "../../../utilis/common";
import { PAGE_TYPE } from "../../../types/pages.type";
import moment from "moment";
import ChartDetailsSearchBar from "../../../components/shared/chart-dialog-common/ChartDetailsSearchBar";
import NoteContainer from "../../../components/shared/NoteContainer";
import AdmissionHeaderFilterList from "./AdmissionHeaderFilterList";
import { filterPatientDataByLevel } from "../../../utilis/custom-tab-filter";
import TrendMappingDialog from "../../../components/shared/chart-dialog-common/TrendMappingDialog";
import { buildInitialTrendConfig, analyzeTrendsLocally } from "../../../utilis/trend-mapping";
import { ADD_NOTIFICATION } from "../../../store/types";
import { store } from "../../../index";
// Helper function to capitalize first letter of a string
const capitalizeFirstLetter = (str) => {
	if (!str || typeof str !== 'string') return str;
	return str.charAt(0).toUpperCase() + str.slice(1);
};

// Helper function to check if an item is truly an average item
// Only items with key/id/_id matching "avarage" or "average" should be considered average
// Other items, even if they have isSpacialItem === true, should be considered regular
const isAverageItem = (item) => {
	if (!item) return false;
	const key = item.key || item.id || item._id || '';
	const keyLower = typeof key === 'string' ? key.toLowerCase() : '';
	return keyLower === 'avarage' || keyLower === 'average';
};

export default function AdmissionCardDetailsDialog({ handleOnClickReport, handleOnClickShareReport, handleGenerateExcelReport }) {
	const isMobileWidth = useMediaQuery('(max-width: 768px)');
	const isMobileLandscape = useMediaQuery('(max-height: 500px) and (max-width: 960px)');
	const isMobile = isMobileWidth || isMobileLandscape;
	const tableElementRef = useRef();
	const buildingElementRef = useRef();
	const [selectedItem, setSelectedItem] = useState([]);
	const [loading, setLoading] = useState(false);
	const [buttonFilterType, setButtonFilterType] = useState(CHART_FILTER_DAY_OF.DAY);
	const [patientData, setPatientData] = useState([]);
	const [censusAverage, setCensusAverage] = useState([]);
	const [censusByPeriod, setCensusByPeriod] = useState([]);
	const [queryFilters, setQueryFilters] = useState(DEFAULT_CHART_FILTER);

	const [defaultPatientData, setDefaultPatientData] = useState([]);
	const [filterData, setFilterData] = useState([]);
	const [chartData, setChartData] = useState(DEFAULT_CHART_DATA);
	const dispatch = useDispatch();
	const [selectedFilter, setSelectedFilter] = useState(FILTER_TYPES.DAILY);
	const {
		detailsDialog: { isOpen, title, data, filters, dbData },
		lockedTotal, lockedTotalBy, lockeByADT,
		cardFilter
	} = useSelector((state) => state.admission);
	
	const { percentageBy } = useSelector((state) => state.common);
	const [selectedTab, setSelectedTab] = useState(filters?.defaultTab ? filters?.defaultTab : CHART_TAB_BUTTON.TABLE);
	const [isShowPercentage, setIsShowPercentage] = useState(false);
	const [censusByFacility, setCensusByFacility] = useState([]);
	const [bedCapacityByFacility, setBedCapacityByFacility] = useState([]);
	const [orderBy, setOrderBy] = useState('dateOfADT'); // Default sort column
	const [order, setOrder] = useState('asc'); // Default sort direction
	// COMPARISON STATES ---------->
	const {
		detailsDialog: { data: dataComparison, filters: filtersComparison },
	} = useSelector((state) => state.admissionComparison);
	const [chartDataComparison, setChartDataComparison] = useState(DEFAULT_CHART_DATA);
	const [censusAverageComparison, setCensusAverageComparison] = useState([]);
	const [censusByPeriodComparison, setCensusByPeriodComparison] = useState([]);
	const [censusByFacilityComparison, setCensusByFacilityComparison] = useState([]);
	const [bedCapacityByFacilityComparison, setBedCapacityByFacilityComparison] = useState([]);
	const [queryFiltersComparison, setQueryFiltersComparison] = useState(DEFAULT_CHART_FILTER);
	const [defaultPatientDataComparison, setDefaultPatientDataComparison] = useState([]);
	const [filterDataComparison, setFilterDataComparison] = useState([]);
	const [selectedItemComparison, setSelectedItemComparison] = useState([]);
	const { rangesSet } = useSelector((state) => state.comparison);
	const [isUpdateRefreshMemo, setIsUpdateRefreshMemo] = useState(false);
	const { auth } = useSelector(({ auth }) => ({ auth }));

	// Trend Mapping state
	const [isTrendMappingOpen, setIsTrendMappingOpen] = useState(false);
	const [trendMappingConfig, setTrendMappingConfig] = useState(null);
	const [trendMappingResult, setTrendMappingResult] = useState(null);
	const [isTrendAnalyzing, setIsTrendAnalyzing] = useState(false);
	const [questions, setQuestions] = React.useState([]);
	const activeFacilities = useSelector((state) => state.activeFacilities.facilities);

	const [selectedFacility, setSelectedFacility] = useState(activeFacilities);
	// Mobile sidebar expand/collapse state
	const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
	// Store combineTab data for filtering
	const combineTabDataRef = useRef(null);
	const combineTabDataComparisonRef = useRef(null);
	// Store customDataArray for isCustomDateAnalysis combine tab filtering (same pattern as Overall/Community/Hospital/Deceased)
	const customDataArrayRef = useRef(null);
	const customDataArrayComparisonRef = useRef(null);
	// Track selected average value for isCustomDateAnalysis combine tab
	const [selectedAverageValue, setSelectedAverageValue] = useState(null);

	const getQuestions = async (activeFacilitiesData) => {
		if (filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab || (filters?.question?.isAnotherDashboard && filters?.question?.dashboardType === DASHBOARD_FILTER_TYPE.COMMUNITY_TRANSFER)) {
			setQuestions([]);
			return;
		}
		setQuestions([]);
		const res = await getAccountQuestions({
			facilityid: activeFacilitiesData,
			accountId: auth.accountId,
			pageType: filters?.question?.isAnotherDashboard ? filters?.question?.dashboardType : DASHBOARD_FILTER_TYPE.ADMISSION,
		})
		if (res && res.length > 0) {
			if (filters?.question?.isAnotherDashboard && filters?.question?.dashboardType === DASHBOARD_FILTER_TYPE.COMMUNITY_TRANSFER) {
				setQuestions([]);
			} else {
				setQuestions(res);
			}
		}
	};

	useEffect(() => {
		getQuestions(activeFacilities);
		// eslint-disable-next-line
	}, [activeFacilities]);

	// * added comparison
	const updateChartArrData = useCallback(async (dataArr, filterType = null, type = null, filter, forComparison, selectedIdsOverride) => {
		try {
			let filterBy = filterType;
			if (!filterType) {
				filterBy = buttonFilterType;
			}
			let chartDataArr = [];
			if (type == "filter" && filter) {
				chartDataArr = await chartsData(dataArr, filter, filters.type);
			} else {
				chartDataArr = await chartsData(dataArr, queryFilters, filters.type);
			}
			let filtersLatest = filter ? filter : forComparison ? queryFiltersComparison : queryFilters;
			let latestChartData = await chartGroupBy(
				chartDataArr,
				filterBy,
				forComparison ? censusAverage : censusAverageComparison,
				forComparison ? censusByPeriod : censusByPeriodComparison,
				filtersLatest
			);

			// Calculate averages from countDay ONLY when:
			// 1. isCustomDateAnalysis is true
			// 2. An average filter is explicitly selected
			// This logic should NOT run for regular filters or non-average items
			if (
				!forComparison &&
				type === "filter" &&
				filters?.question?.customTab?.isCustomDateAnalysis === true &&
				selectedTab === CHART_TAB_BUTTON.CHART &&
				dataArr &&
				dataArr.length > 0
			) {
				
				// Find selected average item from filterData or customDataArrayRef (same pattern as Overall/Community/Hospital/Deceased)
				const dataSource = filterData.length > 0 ? filterData : (customDataArrayRef.current || []);

				// Use the explicit selection that triggered this filter operation when available,
				// otherwise fall back to the current selectedItem state.
				const effectiveSelectedIds = Array.isArray(selectedIdsOverride)
					? selectedIdsOverride
					: selectedItem;

				// Try to find selected average item - MUST be identified by isAverageItem helper
				let selectedAverageItem = null;
				
				// Method 1: Check effectiveSelectedIds (the selection that triggered this call)
				if (effectiveSelectedIds.length > 0) {
					selectedAverageItem = dataSource.find((item) =>
						effectiveSelectedIds.includes(item._id || item.id || item.key) &&
						isAverageItem(item)
					);
				}

				// ONLY process if an average item is actually selected
				// If no average item is selected, skip this entire block and use normal patient count logic
				const hasAverageSelected = !!(selectedAverageItem && isAverageItem(selectedAverageItem));

				if (hasAverageSelected) {
					// Process each period in the chart data to calculate averages
					// Create a new array to ensure React detects the change
					latestChartData = [...latestChartData].map((chartItem) => {
						// Get the date/period from chart item
						const chartDate = chartItem.x; // Format: MM-DD-YYYY for daily, or period labels for others
						
						// Determine date range based on filter type
						let startDate, endDate;
						
						if (filterBy === CHART_FILTER_DAY_OF.DAY) {
							// Daily: exact date match
							startDate = moment(chartDate, ["MM-DD-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
							endDate = startDate;
						} else if (filterBy === CHART_FILTER_DAY_OF.SEVEN || filterBy === CHART_FILTER_DAY_OF.THIRTY) {
							// 7 Days / 30 Days: use endDate if available, otherwise parse from x
							if (chartItem.endDate) {
								endDate = moment(chartItem.endDate).format("YYYY-MM-DD");
								// Calculate start date based on period length
								const days = filterBy === CHART_FILTER_DAY_OF.SEVEN ? 6 : 29;
								startDate = moment(endDate).subtract(days, "days").format("YYYY-MM-DD");
							} else {
								// Fallback: parse from x (format: MM-DD-YYYY)
								endDate = moment(chartDate, ["MM-DD-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
								const days = filterBy === CHART_FILTER_DAY_OF.SEVEN ? 6 : 29;
								startDate = moment(endDate).subtract(days, "days").format("YYYY-MM-DD");
							}
						} else if (filterBy === CHART_FILTER_DAY_OF.WEEK) {
							// Weekly: parse week range from z label or use x as week start
							if (chartItem.z) {
								// z format: "(MM-DD)-(MM-DD)" - e.g., "(01-25)-(01-31)"
								const weekMatch = chartItem.z.match(/\((\d{2}-\d{2})\)/g);
								if (weekMatch && weekMatch.length >= 2) {
									const year = moment(chartDate, ["MM-DD-YYYY", "YYYY-MM-DD"]).year();
									const startMatch = weekMatch[0].match(/(\d{2})-(\d{2})/);
									const endMatch = weekMatch[1].match(/(\d{2})-(\d{2})/);
									if (startMatch && endMatch) {
										startDate = moment(`${year}-${startMatch[1]}-${startMatch[2]}`, "YYYY-MM-DD").format("YYYY-MM-DD");
										endDate = moment(`${year}-${endMatch[1]}-${endMatch[2]}`, "YYYY-MM-DD").format("YYYY-MM-DD");
									}
								}
							}
							if (!startDate || !endDate) {
								// Fallback: use x as week start, calculate week end
								startDate = moment(chartDate, ["MM-DD-YYYY", "YYYY-MM-DD"]).startOf("week").format("YYYY-MM-DD");
								endDate = moment(chartDate, ["MM-DD-YYYY", "YYYY-MM-DD"]).endOf("week").format("YYYY-MM-DD");
							}
						} else if (filterBy === CHART_FILTER_DAY_OF.MONTH) {
							// Monthly: use month start and end
							startDate = moment(chartDate, ["MM-DD-YYYY", "YYYY-MM-DD"]).startOf("month").format("YYYY-MM-DD");
							endDate = moment(chartDate, ["MM-DD-YYYY", "YYYY-MM-DD"]).endOf("month").format("YYYY-MM-DD");
						} else if (filterBy === CHART_FILTER_DAY_OF.QUARTER) {
							// Quarterly: use quarter start and end
							startDate = moment(chartDate, ["MM-DD-YYYY", "YYYY-MM-DD"]).startOf("quarter").format("YYYY-MM-DD");
							endDate = moment(chartDate, ["MM-DD-YYYY", "YYYY-MM-DD"]).endOf("quarter").format("YYYY-MM-DD");
						} else if (filterBy === CHART_FILTER_DAY_OF.YEAR) {
							// Yearly: use year start and end
							startDate = moment(chartDate, ["MM-DD-YYYY", "YYYY-MM-DD"]).startOf("year").format("YYYY-MM-DD");
							endDate = moment(chartDate, ["MM-DD-YYYY", "YYYY-MM-DD"]).endOf("year").format("YYYY-MM-DD");
						} else {
							// Default: exact date match
							startDate = moment(chartDate, ["MM-DD-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
							endDate = startDate;
						}

						// Find patients from dataArr that fall within this date range
						const patientsForPeriod = dataArr.filter(patient => {
							if (!patient.dateOfADT) {
								return false;
							}
							const patientDate = moment(patient.dateOfADT).format("YYYY-MM-DD");
							return patientDate >= startDate && patientDate <= endDate;
						});

						if (patientsForPeriod.length > 0) {
							// Calculate average countDay for patients in this period
							const countDays = patientsForPeriod
								.map(patient => {
									const countDay = Number(patient.countDay);
									return Number.isNaN(countDay) ? null : countDay;
								})
								.filter(val => val !== null);

							if (countDays.length > 0) {
								const sum = countDays.reduce((acc, val) => acc + val, 0);
								const average = sum / countDays.length;
								// Update y value with the average - create completely new object
								return {
									...chartItem,
									y: average,
									total: countDays.length, // Keep total as count for reference
									facilityWiseData: null, // Clear to prevent recalculation
									facilityIds: [], // Clear to prevent facility counting
								};
							}
						}
						
						return chartItem;
					});
				}
			}

			if (type == "filter") {
				forComparison
					? setChartDataComparison((prevState) => ({
						...prevState,
						filterData: latestChartData,
						filterPatients: dataArr,
					}))
					: setChartData((prevState) => ({
						...prevState,
						filterData: latestChartData,
						filterPatients: dataArr,
					}));
			} else {
				forComparison
					? setChartDataComparison((prevState) => ({
						...prevState,
						filterData: latestChartData,
					}))
					: setChartData((prevState) => ({
						...prevState,
						filterData: latestChartData,
					}));
			}
		} catch (e) {
			console.log(e);
		}
	}, [
		buttonFilterType,
		queryFilters,
		queryFiltersComparison,
		censusAverage,
		censusAverageComparison,
		censusByPeriod,
		censusByPeriodComparison,
		selectedTab,
		selectedItem,
		filterData,
		filters,
		customDataArrayRef
	]);

	// * added comparison
	// ! Not sure if comparison needs to be extended to setPatientData. If issues, check here first.
	const filterOptions = useCallback(async (newChecked, mainDataArr, latestButtonFilterType = null, filterObject, forComparison) => {
		setPatientData([]);
		// For combineTab, use defaultPatientData (full dataset) instead of mainDataArr
		let mainData = mainDataArr;
		const isCombineTab = filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab;
		
		if (isCombineTab) {
			// Use the full dataset for combineTab filtering
			mainData = forComparison 
				? (defaultPatientDataComparison.length > 0 ? defaultPatientDataComparison : mainDataArr)
				: (defaultPatientData.length > 0 ? defaultPatientData : mainDataArr);
			
			// For combineTab, we DON'T deduplicate - we need to show all occurrences
			// to match the total count (patients can appear in multiple dashboards)
		}
		
		if (activeFacilities.length > 1) {
			const filterPatientsByFacility = _.filter(mainData, ({ facilityId }) => _.every([_.includes(selectedFacility, facilityId)]));
			mainData = filterPatientsByFacility
		}
		
		if (filters.type === HOSPITAL_CARDS_TYPE.DX_DATA) {
			let newFilters = _.filter(defaultPatientData, ({ dxIds }) => {
				const matchedIds = _.intersection(newChecked, dxIds);
				if (matchedIds.length > 0) {
					return true;
				} else {
					return false;
				}
			});
			setPatientData(newFilters);
			let newChartFilters = _.filter(mainData, ({ dxIds }) => {
				const matchedIds = _.intersection(newChecked, dxIds);
				if (matchedIds.length > 0) {
					return true;
				} else {
					return false;
				}
			});
			await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObject, forComparison);
		} else if (filters.type === HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA) {
			let ninetyDaysDataIds = [];
			let ninetyDaysDataFilter = _.filter(data, ({ _id }) => _.every([_.includes(newChecked, _id)]));
			if (ninetyDaysDataFilter && ninetyDaysDataFilter.length > 0) {
				ninetyDaysDataFilter.map((item) => (ninetyDaysDataIds = [...ninetyDaysDataIds, ...item.ids]));
			}
			let newFilters = _.filter(defaultPatientData, ({ _id }) => _.every([_.includes(ninetyDaysDataIds, _id)]));
			setPatientData(newFilters);
			let newChartFilters = _.filter(mainData, ({ _id }) => _.every([_.includes(ninetyDaysDataIds, _id)]));
			await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObject, forComparison);
		} else if (filters.type === HOSPITAL_CARDS_TYPE.DAYS_DATA) {
			let newFilters = _.filter(defaultPatientData, ({ day }) => {
				return _.every([_.includes(newChecked, day)]);
			});
			setPatientData(newFilters);

			let newChartFilters = _.filter(mainData, ({ day }) => {
				return _.every([_.includes(newChecked, day)]);
			});
			await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObject, forComparison);
		} else if (filters.type === HOSPITAL_CARDS_TYPE.SHIFT_DATA) {
			let newFilters = _.filter(defaultPatientData, ({ shiftName }) => {
				return _.every([_.includes(newChecked, shiftName)]);
			});
			setPatientData(newFilters);
			let newChartFilters = _.filter(mainData, ({ shiftName }) => {
				return _.every([_.includes(newChecked, shiftName)]);
			});
			await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObject, forComparison);
		} else if (filters.type === HOSPITAL_CARDS_TYPE.HOSPITALIZATIONS) {
			if (newChecked.length === 1) {
				let filter = Object();
				if (newChecked[0] == "newHospitalizations") {
					filter.reHospitalization = false;
				}
				if (newChecked[0] == "reHospitalizations") {
					filter.reHospitalization = true;
				}
				let newFilters = _.filter(defaultPatientData, filter);
				setPatientData(newFilters);
				let newChartFilters = _.filter(mainData, filter);

				await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObject, forComparison);
			} else {
				setPatientData(defaultPatientData);
				await updateChartArrData(mainData, latestButtonFilterType, "filter", filterObject, forComparison);
			}
		} else if (filters.type === HOSPITAL_CARDS_TYPE.DCER_DATA) {
			if (newChecked.length === 1) {
				let filter = Object();
				if (newChecked[0] === "DC") {
					filter.wasAdmitted = true;
				}
				if (newChecked[0] === "ER") {
					filter.wasAdmitted = false;
				}
				let newFilters = _.filter(defaultPatientData, filter);
				setPatientData(newFilters);
				let newChartFilters = _.filter(mainData, filter);
				await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObject, forComparison);
			} else {
				setPatientData(defaultPatientData);
				await updateChartArrData(mainData, latestButtonFilterType, "filter", filterObject, forComparison);
			}
		} else if (filters.type === HOSPITAL_CARDS_TYPE.RETURNS_DATA) {
			let filter = Object();
			if (newChecked.length === 1) {
				if (newChecked[0] === "Returned") {
					filter.wasReturned = true;
				}
				if (newChecked[0] === "Didn't Return") {
					filter.wasReturned = false;
				}
				let newFilters = _.filter(defaultPatientData, filter);
				setPatientData(newFilters);
				let newChartFilters = _.filter(mainData, filter);
				await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObject, forComparison);
			} else {
				setPatientData(defaultPatientData);
				await updateChartArrData(mainData, latestButtonFilterType, "filter", filterObject, forComparison);
			}
		} else if (filters.type === ADMISSION_CARDS_TYPE.AVERAGE_STAY_DAYS_DATA) {
			let newFilters = _.filter(defaultPatientData, ({ transferDay }) => {
				return _.every([_.includes(newChecked, transferDay)]);
			});
			setPatientData(newFilters);
			let newChartFilters = _.filter(mainData, ({ transferDay }) => {
				return _.every([_.includes(newChecked, transferDay)]);
			});
		} else {
			// Handle combineTab filtering - filter by patientIds from selected totalByPage entries
			if (isCombineTab) {
				// Check if this is isCustomDateAnalysis combine tab
				const isCustomDateAnalysisCombineTab = filters.question?.customTab?.isCustomDateAnalysis;
				const customDataArray = forComparison 
					? customDataArrayComparisonRef.current
					: customDataArrayRef.current;
				
				if (isCustomDateAnalysisCombineTab && customDataArray && Array.isArray(customDataArray) && customDataArray.length > 0) {
					// Handle isCustomDateAnalysis combine tab filtering
					if (newChecked.length > 0) {
						// Filter by patientIds from selected customDataArray entries
						// DO NOT remove duplicates - we need to show all occurrences to match the total count
						let combinedPatientIds = [];
						newChecked.forEach((selectedId) => {
							const customDataItem = customDataArray.find(item => item._id === selectedId || item.id === selectedId || item.key === selectedId);
							if (customDataItem && customDataItem.patientIds && Array.isArray(customDataItem.patientIds) && customDataItem.patientIds.length > 0) {
								// Convert to strings and add all (including duplicates)
								combinedPatientIds = [...combinedPatientIds, ...customDataItem.patientIds.map(id => String(id))];
							}
						});
						
						if (combinedPatientIds.length > 0) {
							// For combineTab, we need to match each patientId occurrence (not unique)
							// Create a map of patient records for quick lookup
							const patientMap = new Map();
							mainData.forEach((patient) => {
								const patientId = patient._id ? String(patient._id) : (patient.id ? String(patient.id) : null);
								if (patientId) {
									// Store patient record for this ID
									patientMap.set(patientId, patient);
								}
							});
							
							// For each patientId in combinedPatientIds (including duplicates),
							// add the corresponding patient record
							let newChartFilters = [];
							combinedPatientIds.forEach((patientId) => {
								const patient = patientMap.get(patientId);
								if (patient) {
									// Add patient for each occurrence (allows duplicates to match total count)
									newChartFilters.push(patient);
								}
							});
							
							setPatientData(newChartFilters);
							// Pass newChecked so updateChartArrData knows which filter (avg vs regular) is active
							await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObject, forComparison, newChecked);
						} else {
							// No valid patientIds found - show NO data for combineTab
							setPatientData([]);
							await updateChartArrData([], latestButtonFilterType, "filter", filterObject, forComparison, newChecked);
						}
					} else {
						// No selection - for combineTab show NO data
						setPatientData([]);
						await updateChartArrData([], latestButtonFilterType, "filter", filterObject, forComparison, newChecked);
					}
				} else {
					// Handle regular combineTab filtering - filter by patientIds from selected totalByPage entries
					// Use ref to get combineTab data (more reliable than accessing from Redux state)
					const combineTabData = forComparison 
						? combineTabDataComparisonRef.current
						: combineTabDataRef.current;
					
					if (combineTabData?.totalByPage && newChecked.length > 0) {
						// Collect all patientIds from selected totalByPage entries
						// DO NOT remove duplicates - we need to show all occurrences to match the total count
						let combinedPatientIds = [];
						newChecked.forEach((selectedKey) => {
							const pageData = combineTabData.totalByPage[selectedKey];
							if (pageData && pageData.patientIds && Array.isArray(pageData.patientIds) && pageData.patientIds.length > 0) {
								// Convert to strings and add all (including duplicates)
								combinedPatientIds = [...combinedPatientIds, ...pageData.patientIds.map(id => String(id))];
							}
						});
						
						if (combinedPatientIds.length > 0) {
							// For combineTab, we need to match each patientId occurrence (not unique)
							// Create a map of patient records for quick lookup
							const patientMap = new Map();
							mainData.forEach((patient) => {
								const patientId = patient._id ? String(patient._id) : (patient.id ? String(patient.id) : null);
								if (patientId) {
									// Store patient record for this ID
									patientMap.set(patientId, patient);
								}
							});
							
							// For each patientId in combinedPatientIds (including duplicates),
							// add the corresponding patient record
							let newChartFilters = [];
							combinedPatientIds.forEach((patientId) => {
								const patient = patientMap.get(patientId);
								if (patient) {
									// Add patient for each occurrence (allows duplicates to match total count)
									newChartFilters.push(patient);
								}
							});
							
							setPatientData(newChartFilters);
							await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObject, forComparison);
						} else {
							// No valid patientIds found - show NO data for combineTab
							setPatientData([]);
							await updateChartArrData([], latestButtonFilterType, "filter", filterObject, forComparison);
						}
					} else {
						// No selection or no totalByPage - for combineTab show NO data
						setPatientData([]);
						await updateChartArrData([], latestButtonFilterType, "filter", filterObject, forComparison);
					}
				}
			} else {
				const { question } = filters;
				if (question?.isCustom) {
					let newFilters = (filters?.isTotalCard || (filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab && !filters?.question?.customTab?.isCustomDateAnalysis)) ? defaultPatientData : await processCustomChartFilters(
						mainData,
						filters,
						newChecked,
						forComparison
					);

					setPatientData(newFilters);

					let newChartFilters = (filters?.isTotalCard || (filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab && !filters?.question?.customTab?.isCustomDateAnalysis)) ? mainData : await processCustomChartFilters(
						mainData,
						filters,
						newChecked,
						forComparison
					);

					await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObject, forComparison);

				} else {

					let newFilters = filters?.isTotalCard ? defaultPatientData : _.filter(defaultPatientData, ({ filterId }) => {
						return _.every([_.includes(newChecked, filterId)]);
					});
					setPatientData(newFilters);

					let newChartFilters = filters?.isTotalCard ? mainData : _.filter(mainData, ({ filterId }) => {
						return _.every([_.includes(newChecked, filterId)]);
					});
					await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObject, forComparison);
				}
			}
		}
	}, [
		filters,
		defaultPatientData,
		defaultPatientDataComparison,
		activeFacilities,
		selectedFacility,
		data,
		updateChartArrData,
		combineTabDataRef,
		combineTabDataComparisonRef
	]);

	useMemo(() => {
		filterOptions(selectedItem,
			chartData?.mainData,
			buttonFilterType,
			{
				...filters?.filter,
			},
			undefined,
			undefined,
			false
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedFacility, isUpdateRefreshMemo]);

	// * added comparison
	const getPatientChartsData = async () => {
		try {
			setLoading(true);
			if (
				filters.type === ADMISSION_CARDS_TYPE.TOTAL ||
				filters.type === ADMISSION_CARDS_TYPE.READMISSION ||
				filters.type === ADMISSION_CARDS_TYPE.ADMISSION
			) {
				setIsShowPercentage(true);
			}

			let [response, responseComparison] = await Promise.all([
				cardPatientAndChartData({ ...filters, lastADTDate: filters?.lastADTDate }, "main"),
				filtersComparison && rangesSet && cardPatientAndChartData({ ...filtersComparison, lastADTDate: filtersComparison?.lastADTDate }, "comparison"),
			]);
			let latestButtonFilterType = buttonFilterType;
			const isUpdateFilter = isUpdateDefaultFilter(filters.filter);
			if (isUpdateFilter) {
				setSelectedFilter(FILTER_TYPES.WEEKLY);
				latestButtonFilterType = CHART_FILTER_DAY_OF.WEEK;
				setButtonFilterType(CHART_FILTER_DAY_OF.WEEK);
			}

			const resData = await filterPatientDataByLevel({ response, filters, pageType: PAGE_TYPE.ADMISSION });
			if (resData) {
				response.data = resData?.data;
				response.ninetyDaysData = resData?.ninetyDaysData || [];
				response.sixtyDaysData = resData?.sixtyDaysData || [];
			}

			const responseData = response?.data?.map((ele) => { return { ...ele, facilityName: ele?.facility?.name } }) ?? []
			if (response && responseData) {
				setCensusAverage(response.censusAverage);
				setCensusByPeriod(response?.censusByPeriod || []);
				const censusByData = await getChartFacilityPercentageBy(response)
				setCensusByFacility(censusByData);
				setPatientData(responseData);
				setDefaultPatientData(responseData);
				const chartDataArr = await chartsData(responseData, filters.filter , filters.type);
				const latestChartData = await chartGroupBy(
					chartDataArr,
					latestButtonFilterType,
					response.censusAverage,
					response?.censusByPeriod,
					filters.filter
				);
				setChartData({
					mainData: responseData,
					filterPatients: responseData,
					filterData: latestChartData,
				});
			}

			// Handle filterData for combineTab - transform totalByPage into filter items
			let totalByPageFilterData = [];
			if (filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab && data && data.length > 0) {
				const combineTabData = data[0];
				// Store combineTab data in ref for filtering
				combineTabDataRef.current = combineTabData;
				
				// Check if this is isCustomDateAnalysis combine tab (same behavior as Overall/Community/Hospital/Deceased)
				if (
					filters.question?.customTab?.isCustomDateAnalysis &&
					combineTabData?.customDataArray &&
					Array.isArray(combineTabData.customDataArray) &&
					combineTabData.customDataArray.length > 0
				) {
					// Store customDataArray in ref for filtering
					customDataArrayRef.current = combineTabData.customDataArray;
					// Use customDataArray items as filter data
					await setFilterData(combineTabData.customDataArray);
				} else if (combineTabData?.totalByPage) {
					totalByPageFilterData = Object.keys(combineTabData.totalByPage).map((key) => {
						const pageData = combineTabData.totalByPage[key];
						const rawLabel = pageData.label || pageData.dashboard || key;
						const capitalizedLabel = capitalizeFirstLetter(rawLabel);
						return {
							_id: key,
							id: key,
							label: capitalizedLabel,
							name: capitalizedLabel,
							total: pageData.total || 0,
							value: pageData.total || 0,
							percentage: pageData.percentage || "0.0",
							patientIds: pageData.patientIds || [],
							dashboard: pageData.dashboard,
							originalTotal: pageData.total || 0,
							isTooltip: false,
						};
					});
					await setFilterData(totalByPageFilterData);
				} else {
					await setFilterData([]);
				}
			} else if (filters.question?.customTab?.isCustomDateAnalysis && filters?.customRangeCombinedData?.length > 0) {
				// For non-combineTab isCustomDateAnalysis, store customRangeCombinedData in ref
				customDataArrayRef.current = filters.customRangeCombinedData;
				await setFilterData(filters?.customRangeCombinedData);
			} else {
				await setFilterData(data);
			}

			setTimeout(async () => {
				if (filters.selectedFilterData && filters.selectedFilterData.length > 0) {
					// For isCustomDateAnalysis (combine and non-combine), ensure only one type (average or regular) is selected
					// Prefer regular items if both types are present
					let finalSelectedIds = [...filters.selectedFilterData];
					if (
						filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab &&
						filters.question?.customTab?.isCustomDateAnalysis &&
						customDataArrayRef.current &&
						Array.isArray(customDataArrayRef.current) &&
						customDataArrayRef.current.length > 0
					) {
						// Check if selectedFilterData contains both average and regular items
						const selectedAverageItems = filters.selectedFilterData.filter((selectedId) => {
							const item = customDataArrayRef.current.find(
								(item) =>
									item._id === selectedId ||
									item.id === selectedId ||
									item.key === selectedId
							);
							return item !== undefined && isAverageItem(item);
						});
						const selectedRegularItems = filters.selectedFilterData.filter((selectedId) => {
							const item = customDataArrayRef.current.find(
								(item) =>
									item._id === selectedId ||
									item.id === selectedId ||
									item.key === selectedId
							);
							return item !== undefined && !isAverageItem(item);
						});

						// If both types are present, prefer regular items (clear average items)
						if (selectedAverageItems.length > 0 && selectedRegularItems.length > 0) {
							finalSelectedIds = selectedRegularItems;
						}
					} else if (filters.question?.customTab?.isCustomDateAnalysis && 
						filters?.customRangeCombinedData?.length > 0) {
						// For non-combineTab isCustomDateAnalysis, check if both types are selected
						const selectedAverageItems = filters.selectedFilterData.filter((selectedId) => {
							const item = filters.customRangeCombinedData.find(
								(item) =>
									item._id === selectedId ||
									item.id === selectedId ||
									item.key === selectedId
							);
							return item !== undefined && isAverageItem(item);
						});
						const selectedRegularItems = filters.selectedFilterData.filter((selectedId) => {
							const item = filters.customRangeCombinedData.find(
								(item) =>
									item._id === selectedId ||
									item.id === selectedId ||
									item.key === selectedId
							);
							return item !== undefined && !isAverageItem(item);
						});

						// If both types are selected, prefer regular items (clear average items)
						if (selectedAverageItems.length > 0 && selectedRegularItems.length > 0) {
							finalSelectedIds = selectedRegularItems;
						}
					}
					
					setSelectedItem(finalSelectedIds);
					await filterOptions(finalSelectedIds, responseData, latestButtonFilterType, {
						...filters.filter,
						filterData: filters.question?.customTab?.isCustomDateAnalysis && filters?.customRangeCombinedData?.length > 0 ? filters?.customRangeCombinedData : data,
					});
				} else {
					// For combineTab, auto-select all items by default
					if (filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab) {
						// Check if this is isCustomDateAnalysis combine tab
						if (
							filters.question?.customTab?.isCustomDateAnalysis &&
							customDataArrayRef.current &&
							Array.isArray(customDataArrayRef.current) &&
							customDataArrayRef.current.length > 0
						) {
							// Separate average items from regular items
							const averageItems = customDataArrayRef.current.filter(item => isAverageItem(item));
							const regularItems = customDataArrayRef.current.filter(item => !isAverageItem(item));

							// Default selection: prefer regular items, only select average if no regular items exist
							let selectedIds = [];
							if (regularItems.length > 0) {
								// Select all regular items (default behavior)
								selectedIds = regularItems.map((item) => item._id).filter(id => id) || [];
							} else if (averageItems.length > 0) {
								// Only select average items if there are no regular items
								selectedIds = averageItems.map((item) => item._id).filter(id => id) || [];
								// Set selectedAverageValue if an average item is selected by default
								if (selectedIds.length > 0) {
									const avgItem = averageItems.find(item => selectedIds.includes(item._id || item.id || item.key));
									if (avgItem) {
										const avgValue = avgItem.total || avgItem.value || null;
										const numAvgValue = avgValue !== null && avgValue !== undefined ? (typeof avgValue === 'string' ? parseFloat(avgValue) : Number(avgValue)) : null;
										setSelectedAverageValue(!isNaN(numAvgValue) ? numAvgValue : null);
									}
								}
							}

							setSelectedItem(selectedIds);
							// Apply filter with selected items
							if (selectedIds.length > 0 && responseData) {
								await filterOptions(selectedIds, responseData, latestButtonFilterType, {
									...filters.filter,
									filterData: data,
								});
							}
							setIsUpdateRefreshMemo((prevState) => !prevState);
						} else {
							const selectedIds = totalByPageFilterData.map((item) => item._id) || [];
							setSelectedItem(selectedIds);
							// Apply filter with all items selected
							if (selectedIds.length > 0 && responseData) {
								await filterOptions(selectedIds, responseData, latestButtonFilterType, {
									...filters.filter,
									filterData: data,
								});
							}
							setIsUpdateRefreshMemo((prevState) => !prevState);
						}
					} else if (filters.question?.customTab?.isCustomDateAnalysis && filters?.customRangeCombinedData?.length > 0) {
						// For non-combineTab isCustomDateAnalysis, separate average and regular items
						const averageItems = filters.customRangeCombinedData.filter(item => isAverageItem(item));
						const regularItems = filters.customRangeCombinedData.filter(item => !isAverageItem(item));

						// Default selection: prefer regular items, only select average if no regular items exist
						let selectedIds = [];
						if (regularItems.length > 0) {
							selectedIds = regularItems.map(item => item._id).filter(id => id) || [];
						} else if (averageItems.length > 0) {
							selectedIds = averageItems.map(item => item._id).filter(id => id) || [];
							// Set selectedAverageValue if an average item is selected by default
							if (selectedIds.length > 0) {
								const avgItem = averageItems.find(item => selectedIds.includes(item._id || item.id || item.key));
								if (avgItem) {
									const avgValue = avgItem.total || avgItem.value || null;
									const numAvgValue = avgValue !== null && avgValue !== undefined ? (typeof avgValue === 'string' ? parseFloat(avgValue) : Number(avgValue)) : null;
									setSelectedAverageValue(!isNaN(numAvgValue) ? numAvgValue : null);
								}
							}
						}

						setSelectedItem(selectedIds);
						setIsUpdateRefreshMemo((prevState) => !prevState);
					} else {
						const selectedIds = _.map(data, "_id") || [];
						setSelectedItem(selectedIds);
						setIsUpdateRefreshMemo((prevState) => !prevState);
					}
				}
			}, 0);

			if (
				filters.type === ADMISSION_CARDS_TYPE.TOTAL ||
				filters.type === ADMISSION_CARDS_TYPE.READMISSION ||
				filters.type === ADMISSION_CARDS_TYPE.ADMISSION
			) {
				setIsShowPercentage(true);
			}

			// COMPARISON BLOCK
			const resDataComparison = await filterPatientDataByLevel({ responseComparison, filters, pageType: PAGE_TYPE.ADMISSION, forComparison: true });
			if (resDataComparison) {
				responseComparison.data = resDataComparison?.data;
				responseComparison.ninetyDaysData = resDataComparison?.ninetyDaysData;
				responseComparison.sixtyDaysData = resDataComparison?.sixtyDaysData;
			}
			if (responseComparison && responseComparison.data) {
				setCensusAverageComparison(responseComparison.censusAverage);
				setCensusByPeriodComparison(responseComparison.censusByPeriod || []);

				if (responseComparison.censusByFacility) {
					setCensusByFacilityComparison(responseComparison.censusByFacility || []);
				}

				if (responseComparison.bedCapacityByFacility) {
					setBedCapacityByFacilityComparison(responseComparison.bedCapacityByFacility);
				}

				const responseDataComparison = responseComparison.data;
				setDefaultPatientDataComparison(responseDataComparison);
				const chartDataArr = await chartsData(responseDataComparison, filtersComparison?.filter, filtersComparison.type);
				const latestChartData = await chartGroupBy(
					chartDataArr,
					latestButtonFilterType,
					responseComparison.censusAverage,
					responseComparison.censusByPeriod,
					filtersComparison?.filter
				);
				setChartDataComparison({
					mainData: responseDataComparison,
					filterPatients: responseDataComparison,
					filterData: latestChartData,
				});
			}

			// Handle filterDataComparison for combineTab - transform totalByPage into filter items
			let totalByPageFilterDataComparison = [];
			if (filtersComparison?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab && dataComparison && dataComparison.length > 0) {
				const combineTabDataComparison = dataComparison[0];
				// Store combineTab comparison data in ref for filtering
				combineTabDataComparisonRef.current = combineTabDataComparison;
				
				// Check if this is isCustomDateAnalysis combine tab
				if (filtersComparison.question?.customTab?.isCustomDateAnalysis && combineTabDataComparison?.customDataArray && Array.isArray(combineTabDataComparison.customDataArray) && combineTabDataComparison.customDataArray.length > 0) {
					// Store customDataArray in ref for filtering
					customDataArrayComparisonRef.current = combineTabDataComparison.customDataArray;
					// Use customDataArray items as filter data
					setFilterDataComparison(combineTabDataComparison.customDataArray);
				} else if (combineTabDataComparison?.totalByPage) {
					totalByPageFilterDataComparison = Object.keys(combineTabDataComparison.totalByPage).map((key) => {
						const pageData = combineTabDataComparison.totalByPage[key];
						const rawLabel = pageData.label || pageData.dashboard || key;
						const capitalizedLabel = capitalizeFirstLetter(rawLabel);
						return {
							_id: key,
							id: key,
							label: capitalizedLabel,
							name: capitalizedLabel,
							total: pageData.total || 0,
							value: pageData.total || 0,
							percentage: pageData.percentage || "0.0",
							patientIds: pageData.patientIds || [],
							dashboard: pageData.dashboard,
							originalTotal: pageData.total || 0,
							isTooltip: false,
						};
					});
					setFilterDataComparison(totalByPageFilterDataComparison);
				} else {
					setFilterDataComparison([]);
				}
			} else if (filtersComparison?.question?.customTab?.isCustomDateAnalysis && filtersComparison?.customRangeCombinedData?.length > 0) {
				// For non-combineTab isCustomDateAnalysis, store customRangeCombinedData in ref
				customDataArrayComparisonRef.current = filtersComparison.customRangeCombinedData;
				setFilterDataComparison(filtersComparison?.customRangeCombinedData);
			} else {
				setFilterDataComparison(dataComparison);
			}

			setTimeout(async () => {
				if (filtersComparison?.selectedFilterData && filtersComparison?.selectedFilterData.length > 0) {
					// For isCustomDateAnalysis combine tab, ensure only one type (average or regular) is selected
					// Prefer regular items if both types are present
					let finalSelectedIdsComparison = [...filtersComparison?.selectedFilterData];
					if (filtersComparison?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab && 
						filtersComparison.question?.customTab?.isCustomDateAnalysis && 
						customDataArrayComparisonRef.current && 
						Array.isArray(customDataArrayComparisonRef.current) && 
						customDataArrayComparisonRef.current.length > 0) {
						// Check if selectedFilterData contains both average and regular items
						const selectedAverageItems = filtersComparison.selectedFilterData.filter(selectedId => {
							const item = customDataArrayComparisonRef.current.find(item => 
								(item._id === selectedId || item.id === selectedId || item.key === selectedId) && 
								isAverageItem(item)
							);
							return item !== undefined;
						});
						const selectedRegularItems = filtersComparison.selectedFilterData.filter(selectedId => {
							const item = customDataArrayComparisonRef.current.find(item => 
								(item._id === selectedId || item.id === selectedId || item.key === selectedId) && 
								!isAverageItem(item)
							);
							return item !== undefined;
						});
						
						// If both types are selected, prefer regular items (clear average items)
						if (selectedAverageItems.length > 0 && selectedRegularItems.length > 0) {
							finalSelectedIdsComparison = selectedRegularItems;
						}
					} else if (filtersComparison.question?.customTab?.isCustomDateAnalysis && 
						filtersComparison?.customRangeCombinedData?.length > 0) {
						// For non-combineTab isCustomDateAnalysis, check if both types are selected
						const selectedAverageItems = filtersComparison.selectedFilterData.filter(selectedId => {
							const item = filtersComparison.customRangeCombinedData.find(item => 
								(item._id === selectedId || item.id === selectedId || item.key === selectedId) && 
								isAverageItem(item)
							);
							return item !== undefined;
						});
						const selectedRegularItems = filtersComparison.selectedFilterData.filter(selectedId => {
							const item = filtersComparison.customRangeCombinedData.find(item => 
								(item._id === selectedId || item.id === selectedId || item.key === selectedId) && 
								!isAverageItem(item)
							);
							return item !== undefined;
						});
						
						// If both types are selected, prefer regular items (clear average items)
						if (selectedAverageItems.length > 0 && selectedRegularItems.length > 0) {
							finalSelectedIdsComparison = selectedRegularItems;
						}
					}
					
					setSelectedItemComparison(finalSelectedIdsComparison);
					await filterOptions(
						finalSelectedIdsComparison,
						responseComparison.data,
						latestButtonFilterType,
						{
							...filtersComparison?.filter,
							filterData: filtersComparison?.question?.customTab?.isCustomDateAnalysis && filtersComparison?.customRangeCombinedData?.length > 0 ? filtersComparison?.customRangeCombinedData : dataComparison,
						},
						true
					);
				} else {
					// For combineTab, auto-select all items by default
					if (filtersComparison?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab) {
						// Check if this is isCustomDateAnalysis combine tab
						if (filtersComparison.question?.customTab?.isCustomDateAnalysis && customDataArrayComparisonRef.current && Array.isArray(customDataArrayComparisonRef.current) && customDataArrayComparisonRef.current.length > 0) {
							// Separate average items from regular items
							const averageItems = customDataArrayComparisonRef.current.filter(item => isAverageItem(item));
							const regularItems = customDataArrayComparisonRef.current.filter(item => !isAverageItem(item));
							
							// Default selection: prefer regular items, only select average if no regular items exist
							let selectedIdsComparison = [];
							if (regularItems.length > 0) {
								// Select all regular items (default behavior)
								selectedIdsComparison = regularItems.map((item) => item._id).filter(id => id) || [];
							} else if (averageItems.length > 0) {
								// Only select average items if there are no regular items
								selectedIdsComparison = averageItems.map((item) => item._id).filter(id => id) || [];
							}
							
							setSelectedItemComparison(selectedIdsComparison);
							// Apply filter with selected items
							if (selectedIdsComparison.length > 0 && responseComparison?.data) {
								await filterOptions(
									selectedIdsComparison,
									responseComparison.data,
									latestButtonFilterType,
									{
										...filtersComparison?.filter,
										filterData: dataComparison,
									},
									true
								);
							}
						} else {
							const selectedIdsComparison = totalByPageFilterDataComparison.map((item) => item._id) || [];
							setSelectedItemComparison(selectedIdsComparison);
							// Apply filter with all items selected
							if (selectedIdsComparison.length > 0 && responseComparison?.data) {
								await filterOptions(
									selectedIdsComparison,
									responseComparison.data,
									latestButtonFilterType,
									{
										...filtersComparison?.filter,
										filterData: dataComparison,
									},
									true
								);
							}
						}
					} else if (filtersComparison?.question?.customTab?.isCustomDateAnalysis && filtersComparison?.customRangeCombinedData?.length > 0) {
						// For non-combineTab isCustomDateAnalysis, separate average and regular items
						const averageItems = filtersComparison.customRangeCombinedData.filter(item => isAverageItem(item));
						const regularItems = filtersComparison.customRangeCombinedData.filter(item => !isAverageItem(item));
						
						// Default selection: prefer regular items, only select average if no regular items exist
						let selectedIds = [];
						if (regularItems.length > 0) {
							selectedIds = regularItems.map(item => item._id).filter(id => id) || [];
						} else if (averageItems.length > 0) {
							selectedIds = averageItems.map(item => item._id).filter(id => id) || [];
						}
						
						setSelectedItemComparison(selectedIds);
					} else {
						const selectedIds = _.map(dataComparison, "_id") || [];
						setSelectedItemComparison(selectedIds);
					}
				}
			}, 0);
		} catch (e) {
			console.log(e);
		} finally {
			setLoading(false);
		}
	};

	// * added comparison
	const reloadChartData = useCallback(
		async (startDate, endDate, startDateComparison, endDateComparison) => {
			try {
				setLoading(true);
				let filterObj = { ...filters, filter: { startDate, endDate } };
				let filterObjComparison = {
					...filtersComparison,
					filter: { startDate: startDateComparison, endDate: endDateComparison },
				};

				let latestButtonFilterType = buttonFilterType;
				const isUpdateFilter = isUpdateDefaultFilter(filterObj.filter);

				if (isUpdateFilter) {
					setSelectedFilter(FILTER_TYPES.WEEKLY);
					latestButtonFilterType = CHART_FILTER_DAY_OF.WEEK;
					setButtonFilterType(CHART_FILTER_DAY_OF.WEEK);
				}
				let [response, responseComparison] = await Promise.all([
					cardPatientAndChartData({ ...filterObj }, "reload"),
					filterObjComparison && cardPatientAndChartData({ ...filterObjComparison }, "reloadCompare"),
				]);
				const resData = await filterPatientDataByLevel({ response, filterObj });
				if (resData) {
					response.data = resData?.data;
					response.ninetyDaysData = resData?.ninetyDaysData;
					response.sixtyDaysData = resData?.sixtyDaysData;
				}
				const responseData = response?.data?.map((ele) => { return { ...ele, facilityName: ele?.facility?.name } }) ?? []
				if (response && responseData && responseData.length > 0) {
					setCensusAverage(response.censusAverage);
					setCensusByPeriod(response?.censusByPeriod || []);
					const censusByData = await getChartFacilityPercentageBy(response)
					setCensusByFacility(censusByData);
					const chartDataArr = await chartsData(responseData, filterObj.filter, filters.type);
					const latestChartData = await chartGroupBy(
						chartDataArr,
						latestButtonFilterType,
						response.censusAverage,
						response?.censusByPeriod,
						filterObj.filter
					);

					setChartData({
						mainData: responseData,
						filterPatients: responseData,
						filterData: latestChartData,
					});
					if (selectedItem.length > 0) {
						await filterOptions(selectedItem, responseData, latestButtonFilterType, filterObj.filter);
					}
				}

				const resDataComparison = await filterPatientDataByLevel({ responseComparison, filters, pageType: PAGE_TYPE.ADMISSION, forComparison: true });
				if (resDataComparison) {
					responseComparison.data = resDataComparison?.data;
					responseComparison.ninetyDaysData = resDataComparison?.ninetyDaysData;
					responseComparison.sixtyDaysData = resDataComparison?.sixtyDaysData;
				}
				if (responseComparison && responseComparison.data && responseComparison.data.length > 0) {
					setCensusAverageComparison(responseComparison.censusAverage);
					setCensusByPeriodComparison(responseComparison.censusByPeriod || []);

					if (responseComparison.censusByFacility) {
						setCensusByFacilityComparison(responseComparison.censusByFacility || []);
					}

					if (responseComparison.bedCapacityByFacility) {
						setBedCapacityByFacilityComparison(responseComparison.bedCapacityByFacility);
					}

					const chartDataArrComparison = await chartsData(responseComparison.data, filterObjComparison.filter, filtersComparison.type);
					const latestChartDataComparison = await chartGroupBy(
						chartDataArrComparison,
						latestButtonFilterType,
						responseComparison.censusAverage,
						responseComparison.censusByPeriod,
						filterObjComparison.filter
					);

					setChartDataComparison({
						mainData: responseComparison.data,
						filterPatients: responseComparison.data,
						filterData: latestChartDataComparison,
					});
					if (selectedItem.length > 0) {
						await filterOptions(
							selectedItemComparison,
							responseComparison.data,
							latestButtonFilterType,
							filterObjComparison.filter,
							true
						);
					}
				}
			} catch (e) {
				console.log(e);
			} finally {
				setLoading(false);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[buttonFilterType, selectedItem, selectedItemComparison]
	);

	// * added comparison
	const reset = () => {
		setSelectedItem([]);
		setPatientData([]);
		setDefaultPatientData([]);
		setFilterData([]);

		setSelectedItemComparison([]);
		setDefaultPatientDataComparison([]);
		setFilterDataComparison([]);
		
		// Reset combineTab data refs
		combineTabDataRef.current = null;
		combineTabDataComparisonRef.current = null;
		// Reset customDataArray refs and selected average value
		customDataArrayRef.current = null;
		customDataArrayComparisonRef.current = null;
		setSelectedAverageValue(null);
	};

	// * added comparison
	const handleToggle = useCallback(
		async (value) => {
			const isCustomDateAnalysisCombineTab =
				filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab &&
				filters?.question?.customTab?.isCustomDateAnalysis;

			// Check if the item being toggled is an average item (special item)
			// Only items with key/id/_id === "avarage" or "average" are considered average
			const toggledItem = filterData.find(
				(item) => item._id === value || item.id === value || item.key === value
			);
			const isAverageItemToggled = toggledItem ? isAverageItem(toggledItem) : false;

			const currentIndex = selectedItem.indexOf(value);
			let newChecked = [...selectedItem];

			if (currentIndex === -1) {
				// Item is being selected
				if (isCustomDateAnalysisCombineTab && isAverageItemToggled) {
					// If selecting average, clear all regular items and set average value
					newChecked = [value]; // Only keep the average item
					const avgValue = toggledItem?.total || toggledItem?.value || null;
					// Convert to number if it's a string
					const numAvgValue =
						avgValue !== null && avgValue !== undefined
							? typeof avgValue === "string"
								? parseFloat(avgValue)
								: Number(avgValue)
							: null;
					setSelectedAverageValue(isNaN(numAvgValue) ? null : numAvgValue);
				} else if (isCustomDateAnalysisCombineTab && !isAverageItemToggled) {
					// If selecting regular item, clear average item if any
					// Find and remove any average items from selection
					// Only items with key/id/_id === "avarage" or "average" are considered average
					const averageItems = filterData
						.filter((item) => isAverageItem(item))
						.map((item) => item._id || item.id || item.key);
					newChecked = newChecked.filter((id) => !averageItems.includes(id));
					newChecked.push(value);
					setSelectedAverageValue(null); // Clear average value
				} else {
					// Regular selection (not isCustomDateAnalysis combine tab)
					newChecked.push(value);
					setSelectedAverageValue(null); // Ensure no average when selecting regular
				}
			} else {
				// Item is being deselected
				newChecked.splice(currentIndex, 1);
				// If deselecting average item, clear average value
				if (isAverageItemToggled) {
					setSelectedAverageValue(null);
				}
			}

			// IMPORTANT: update selectedItem BEFORE filtering so updateChartArrData sees the new selection
			setSelectedItem(newChecked);

			// For combineTab, use defaultPatientData (original unfiltered data) as source
			// This applies to both regular combineTab and isCustomDateAnalysis combineTab
			const mainDataSource =
				filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab
					? defaultPatientData.length > 0
						? defaultPatientData
						: chartData.mainData
					: chartData.mainData;
			const comparisonDataSource =
				filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab
					? defaultPatientDataComparison.length > 0
						? defaultPatientDataComparison
						: chartDataComparison.mainData
					: chartDataComparison.mainData;

			if (newChecked.length > 0) {
				await Promise.all([
					filterOptions(newChecked, mainDataSource, buttonFilterType),
					filterOptions(
						newChecked,
						comparisonDataSource,
						buttonFilterType,
						undefined,
						true
					),
				]);
			} else {
				// For combineTab (both regular and isCustomDateAnalysis), show NO data when nothing is selected
				// This matches the behavior in filterOptions where empty selection shows no data
				if (filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab) {
					await Promise.all([
						filterOptions([], mainDataSource, buttonFilterType),
						filterOptions(
							[],
							comparisonDataSource,
							buttonFilterType,
							undefined,
							true
						),
					]);
				} else {
					setPatientData([]);
					setChartData((prevState) => ({
						...prevState,
						filterData: [],
						filterPatients: [],
					}));
					setChartDataComparison((prevState) => ({
						...prevState,
						filterData: [],
						filterPatients: [],
					}));
				}
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			selectedItem,
			chartData.mainData,
			buttonFilterType,
			chartDataComparison.mainData,
			filters,
			defaultPatientData,
			defaultPatientDataComparison,
			filterData,
		]
	);

	// * added comparison
	const handleClickFilter = useCallback(
		async (type, filterType = null) => {
			setSelectedFilter(type);
			setButtonFilterType(filterType);
			await Promise.all([
				updateChartArrData(chartData.filterPatients, filterType),
				updateChartArrData(chartDataComparison.filterPatients, filterType, undefined, undefined, true),
			]);
			if (selectedItem.length > 0) {
				await Promise.all([
					filterOptions(selectedItem, chartData.mainData, filterType),
					filterOptions(selectedItem, chartDataComparison.mainData, filterType, undefined, true),
				]);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			updateChartArrData,
			chartData.filterPatients,
			chartData.mainData,
			chartDataComparison.filterPatients,
			chartDataComparison.mainData,
			selectedItem,
		]
	);

	// * added comparison
	const handleChartLabelType = useCallback(
		async (type) => {
			setQueryFilters((prevState) => ({
				...prevState,
				chartPointType: type,
			}));
			setQueryFiltersComparison((prevState) => ({
				...prevState,
				chartPointType: type,
			}));
			await Promise.all([
				updateChartArrData(chartData.filterPatients),
				updateChartArrData(chartDataComparison?.filterPatients, undefined, undefined, undefined, true),
			]);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[chartData.filterPatients, chartDataComparison?.filterPatients]
	);

	// * added comparison
	const handleToggleAll = useCallback(
		async (value) => {
			if (value == "all") {
				// Check if this is isCustomDateAnalysis combine tab
				const isCustomDateAnalysisCombineTab =
					filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab &&
					filters?.question?.customTab?.isCustomDateAnalysis;

				let ids = [];
				if (isCustomDateAnalysisCombineTab && Array.isArray(filterData) && filterData.length > 0) {
					// For isCustomDateAnalysis combine tab, only select regular items (exclude average items)
					// Only items with key/id/_id === "avarage" or "average" are considered average
					const regularItems = filterData.filter((item) => !isAverageItem(item));
					ids = regularItems.map((a) => a._id).filter((id) => id) || [];
				} else {
					// For regular tabs, select all items
					ids = filterData?.map((a) => a._id) || [];
				}
				const idsComparison = filterDataComparison?.map((x) => x._id);

				await Promise.all([
					filterOptions(ids, chartData.mainData, buttonFilterType),
					filterOptions(idsComparison, chartDataComparison.mainData, buttonFilterType, undefined, true),
				]);
				setSelectedItem([...ids]);
				setSelectedItemComparison([...idsComparison]);
			} else {
				setPatientData([]);
				setChartData((prevState) => ({
					...prevState,
					filterData: [],
					filterPatients: [],
				}));
				setSelectedItem([]);
				setChartDataComparison((prevState) => ({
					...prevState,
					filterData: [],
					filterPatients: [],
				}));
				setSelectedItemComparison([]);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[filterData, filterDataComparison, chartData.mainData, buttonFilterType, chartDataComparison.mainData, filters]
	);

	const handleClose = useCallback(() => {
		dispatch(closeDetailsDialog());
	}, [dispatch]);

	const handleTabButton = useCallback((type) => {
		setSelectedTab(type);
	}, []);

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const getFieldNames = useCallback((row) => {
		return getAdmissionFieldNames(row, filters?.relation, filters?.type, data, filters);
	}, [data, filters]);

	const onClickReport = useCallback(
		(title, automaticallyReport) => {
			handleOnClickReport({
				selectedTab,
				filters,
				chartData: {
					...chartData,
					filterPatients: patientDataOrderBy(chartData?.filterPatients, order, orderBy, {
						getTypeSortLabel: getFieldNames,
					})
				},
				selectedFilter,
				tableElementRef,
				buildingElementRef,
				title,
				queryFilters,
				selectedItem,
				filterData,
				automaticallyReport,
				buttonFilterType,
				orderBy,
				order,
				activeFacilitiesCount: activeFacilities?.length
			});
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			selectedTab,
			filters,
			chartData,
			tableElementRef,
			buildingElementRef,
			queryFilters,
			selectedItem,
			filterData,
			buttonFilterType,
			orderBy,
			order,
			activeFacilities,
			getFieldNames
		]
	);

	const onClickShareReport = useCallback(
		(title) => {
			if (handleOnClickShareReport) {
				// Pass Excel data for chart dialogs - same data used in handleExcelReport
				handleOnClickShareReport(title, {
					type: filters?.type || '',
					isTotalCard: filters?.isTotalCard || false,
					useExcel: true,
					excelData: {
						data: chartData?.filterPatients,
						filters,
						pageType: DASHBOARD_FILTER_TYPE.ADMISSION,
						getFieldNames,
						title,
						censusAverage,
						bedCapacity: dbData?.bedCapacity || 0,
						questions,
						selectedColumns: [], // Default to empty, user can select columns in share dialog if needed
						orderBy,
						order,
						activeFacilitiesCount: activeFacilities?.length
					}
				});
			}
		},
		[handleOnClickShareReport, chartData?.filterPatients, filters, getFieldNames, censusAverage, dbData, questions, orderBy, order, activeFacilities]
	);

	// * added comparison
	useEffect(() => {
		reset();
		if (filters && filters.filter) {
			const daysFilter = chartFilterPermission(filters.filter);
			const daysDiff = dayDifferent(filters.filter);

			setQueryFilters({
				filterButtons: daysFilter,
				days: daysDiff,
				startDate: filters.filter.startDate,
				endDate: filters.filter.endDate,
				chartPointType: CHART_POINT_TYPE.TOTAL,
			});
			getPatientChartsData();
		}
		if (filtersComparison && filtersComparison?.filter && rangesSet) {
			const daysFilter = chartFilterPermission(filtersComparison?.filter);
			const daysDiff = dayDifferent(filtersComparison?.filter);

			setQueryFiltersComparison({
				filterButtons: daysFilter,
				days: daysDiff,
				startDate: filtersComparison?.filter.startDate,
				endDate: filtersComparison?.filter.endDate,
				chartPointType: CHART_POINT_TYPE.TOTAL,
			});
			getPatientChartsData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filters?.filter, filtersComparison?.filter, rangesSet]);

	const handleExcelReport = useCallback((selectedColumns = []) => {
		handleGenerateExcelReport({
			data: chartData?.filterPatients,
			filters,
			pageType: DASHBOARD_FILTER_TYPE.ADMISSION,
			getFieldNames,
			title,
			censusAverage,
			bedCapacity: dbData?.bedCapacity || 0,
			questions,
			selectedColumns,
			orderBy,
			order,
			activeFacilitiesCount: activeFacilities?.length
		});
	}, [chartData?.filterPatients, filters, handleGenerateExcelReport, title, censusAverage, dbData, questions, orderBy, order, activeFacilities]); // eslint-disable-line react-hooks/exhaustive-deps

	// below code use for search filter in table
	const [searchTerm, setSearchTerm] = useState('');
	const [totalHighlightedCount, setTotalHighlightedCount] = useState(0);
	const [debounceHighlightedCount, setDebounceHighlightedCount] = useState(0);
	const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
	const [highlightedCountDefaultValue, setHighlightedCountDefaultValue] = useState(0);
	const [selectedHighlightedColumns, setSelectedHighlightedColumns] = useState([]);

	// useEffect(() => {
	// 	if (questions && questions.length > 0) {
	// 		setSelectedHighlightedColumns([...questions?.map((ele) => ele?.question?.accessor), ...tableDefaultQuestions.map((ele) => ele?.question?.accessor), "selectAll"]);
	// 	}
	// }, [questions]);

	const [filterType, setFilterType] = useState({ type: '', filter: '', operation: '' });

	useEffect(() => {
		const handlerCount = _.debounce(() => setDebounceHighlightedCount(totalHighlightedCount), 200);
		handlerCount();
		return () => handlerCount.cancel();
	}, [totalHighlightedCount]);

	useEffect(() => {
		const handler = _.debounce(() => {
			setDebouncedSearchTerm(searchTerm);
			setFilterType({ type: typeof searchTerm, filter: searchTerm, operation: '' });
		}, 150);
		handler();
		return () => handler.cancel();
	}, [searchTerm]);

	const handleSearch = (event) => {
		const value = event.target.value;
		setSearchTerm(isNaN(value) || !value ? value : Number(value));
	};

	const handleHighlightedCount = useCallback((count) => {
		setTotalHighlightedCount(searchTerm ? count : 0);
	}, [searchTerm]);

	// end of below code use for search filter in table

	// Trend Mapping handlers
	const handleOpenTrendMapping = useCallback(() => {
		const baseConfig = buildInitialTrendConfig({
			pageType: PAGE_TYPE.ADMISSION,
			dialogFilters: filters,
			queryFilters,
			selectedCardType: filters?.type,
			selectedItems: selectedItem,
		});

		setTrendMappingConfig(baseConfig);
		setTrendMappingResult(null);
		setIsTrendMappingOpen(true);
	}, [filters, queryFilters, selectedItem]);

	const handleAnalyzeTrendMapping = useCallback(
		async (config) => {
			try {
				setIsTrendAnalyzing(true);
				dispatch({
					type: ADD_NOTIFICATION,
					payload: {
						id: "trendMappingInProgressAdmission",
						type: "info",
						label:
							"Trend analysis is in progress. You will be notified once it is completed.",
					},
				});

				// Determine Trend Mapping filter mode from config
				const filterMode = config?.filterMode || "keepAll";
				const selectedFilterCards = Array.isArray(config?.selectedFilterCards)
					? config.selectedFilterCards
					: [];

				// Prepare dialogFilters + config that will actually be sent to analyzeTrendsLocally.
				// We implement "Keep Some Filters" here by trimming cardFilter to ONLY the selected filters,
				// so the analyzer can treat it as a simple "keepAll" over that reduced filter set.
				let trendDialogFilters;
				let trendConfigForAnalysis = config;

				if (filterMode === "removeAll") {
					// User explicitly asked to ignore ALL existing dashboard filters
					trendDialogFilters = {
						...filters,
						cardFilter: {},
						// Ensure patientListFromPage, dynamicCards, and ninetyDaysData are included
						patientListFromPage: filters?.patientListFromPage,
						dynamicCards: filters?.dynamicCards,
						ninetyDaysData: filters?.ninetyDaysData,
					};
				} else if (filterMode === "keepSome") {
					const originalCardFilter = filters?.cardFilter || {};
					const keptSet = new Set(selectedFilterCards);
					const trimmedCardFilter = {};
					const currentCardType = filters?.type;

					// CRITICAL: For admission page, use mainPriorityData instead of priorityData
					// Other pages use priorityData, but admission page uses mainPriorityData
					// Also respect priority order - if current card is in mainPriorityData,
					// include filters BEFORE it AND the current card itself (using selectedItem from left sidebar)
					const mainPriorityData = originalCardFilter.mainPriorityData || [];
					const priorityData = originalCardFilter.priorityData || [];

					// Helper to filter and trim priority data respecting priority order
					const filterPriorityData = (priorityDataArray) => {
						if (!Array.isArray(priorityDataArray) || priorityDataArray.length === 0) return [];
						
						// Find the index of current card type in priorityData
						let currentCardIndex = -1;
						if (currentCardType) {
							currentCardIndex = priorityDataArray.findIndex((ele) => ele && ele.type === currentCardType);
						}
						
						// Determine how many filters to process
						// If current card is in priorityData, include it (so process up to and including that index)
						// If current card is not in priorityData, process all filters
						const maxIndex = currentCardIndex >= 0 ? currentCardIndex + 1 : priorityDataArray.length;
						
						// Filter to only kept types AND only those up to current card in priority order
						let filtered = priorityDataArray
							.slice(0, maxIndex) // Include filters before current card AND current card itself
							.filter((ele) => ele && keptSet.has(ele.type)); // Only keep selected filters
						
						// CRITICAL: If current card is in the filtered list, update it to use selectedItem from left sidebar
						if (currentCardIndex >= 0 && currentCardType && selectedItem && Array.isArray(selectedItem) && selectedItem.length > 0) {
							const currentCardInFiltered = filtered.find((ele) => ele && ele.type === currentCardType);
							if (currentCardInFiltered) {
								// Extract IDs from selectedItem
								const selectedItemIds = selectedItem.map(item => {
									if (typeof item === 'object' && item !== null) {
										return item._id || item.id || item.key || item.name || item.label || item.value;
									}
									return item;
								}).filter(Boolean);
								
								if (selectedItemIds.length > 0) {
									// Update the entry to use selected items from left sidebar
									const index = filtered.indexOf(currentCardInFiltered);
									filtered[index] = {
										...currentCardInFiltered,
										items: selectedItemIds,
										selectedItems: selectedItemIds,
									};
								}
							}
						}
						
						return filtered;
					};

					// For admission page, trim mainPriorityData; for other pages, trim priorityData
					const trimmedMainPriorityData = filterPriorityData(mainPriorityData);
					const trimmedPriorityData = filterPriorityData(priorityData);

					// Always set mainPriorityData for admission page (even if empty, to maintain structure)
					trimmedCardFilter.mainPriorityData = trimmedMainPriorityData;
					// Set priorityData for other pages
					if (trimmedPriorityData.length > 0) {
						trimmedCardFilter.priorityData = trimmedPriorityData;
					}

					// Copy only the card filters the user decided to keep
					Object.keys(originalCardFilter).forEach((key) => {
						if (key === "priorityData" || key === "mainPriorityData") return;
						const value = originalCardFilter[key];
						if (!Array.isArray(value) || value.length === 0) return;
						if (!keptSet.has(key)) return;
						trimmedCardFilter[key] = value;
					});
					
					// CRITICAL: If current card is in selectedFilterCards, ensure it uses selectedItem from left sidebar
					// This ensures the current card's filter is applied based on what's selected in the left sidebar
					if (currentCardType && keptSet.has(currentCardType)) {
						if (selectedItem && Array.isArray(selectedItem) && selectedItem.length > 0) {
							// Extract IDs from selectedItem
							const selectedItemIds = selectedItem.map(item => {
								if (typeof item === 'object' && item !== null) {
									return item._id || item.id || item.key || item.name || item.label || item.value;
								}
								return item;
							}).filter(Boolean);
							
							if (selectedItemIds.length > 0) {
								// Use selected items from left sidebar for current card
								trimmedCardFilter[currentCardType] = selectedItemIds;
							}
						} else {
							// Fallback: if selectedItem is empty, use existing filter if available
							const existingFilter = originalCardFilter[currentCardType];
							if (existingFilter && Array.isArray(existingFilter) && existingFilter.length > 0) {
								trimmedCardFilter[currentCardType] = existingFilter;
							}
						}
					}

					trendDialogFilters = {
						...filters,
						cardFilter: trimmedCardFilter,
						// Ensure patientListFromPage, dynamicCards, and ninetyDaysData are included
						patientListFromPage: filters?.patientListFromPage,
						dynamicCards: filters?.dynamicCards,
						ninetyDaysData: filters?.ninetyDaysData,
					};

					// Tell analyzer to just "keepAll" on this already-trimmed filter set.
					trendConfigForAnalysis = {
						...config,
						filterMode: "keepAll",
					};
				} else {
					// keepAll - pass filters as-is, but extract card types from mainPriorityData/priorityData
					// and ensure they exist as direct keys in cardFilter so the analysis can find them
					// CRITICAL: For admission page, mainPriorityData is primary (not priorityData)
					// CRITICAL: When a card type is in mainPriorityData/priorityData, the selected items
					// should already be in cardFilter[cardType], but we need to ensure it exists even if
					// it's only in the priorityData array structure
					// 
					// IMPORTANT: Respect priority order - if current card type matches a card in mainPriorityData,
					// include filters BEFORE it AND the current card itself (using selectedItem from left sidebar)
					const originalCardFilter = filters?.cardFilter || {};
					const expandedCardFilter = { ...originalCardFilter };
					const currentCardType = filters?.type;
					
					// Helper function to process priority data with priority order respect
					const processPriorityData = (priorityDataArray, isMainPriority = false) => {
						if (!Array.isArray(priorityDataArray) || priorityDataArray.length === 0) return;
						
						// Find the index of current card type in priorityData
						// If found, we need to:
						// 1. Process filters BEFORE it (these are applied)
						// 2. Include current card's filter from left sidebar (selectedItem)
						// 3. Exclude filters AFTER it (these should not be applied)
						let currentCardIndex = -1;
						if (currentCardType) {
							currentCardIndex = priorityDataArray.findIndex((ele) => ele && ele.type === currentCardType);
						}
						
						// Determine how many filters to process
						// If current card is in priorityData, only process up to (but not including) that index
						// If current card is not in priorityData, process all filters
						const maxIndex = currentCardIndex >= 0 ? currentCardIndex : priorityDataArray.length;
						
						// Process only filters that come BEFORE the current card in priority order
						for (let i = 0; i < maxIndex; i++) {
							const ele = priorityDataArray[i];
							if (ele && ele.type) {
								const cardType = ele.type;
								// CRITICAL: Ensure the card type exists as a direct key with selected items
								// The analysis function expects cardFilter[cardType] to be an array of selected items
								// If it doesn't exist or is empty, we need to get the selected items from the right source
								const existingFilter = expandedCardFilter[cardType];
								if (!existingFilter || !Array.isArray(existingFilter) || existingFilter.length === 0) {
									// Try multiple sources for the selected items (in order of preference):
									// 1. Check if it's already in originalCardFilter (should be there if filter was applied)
									// 2. Check ele.items or ele.selectedItems (if stored in priorityData entry)
									// Note: Don't use filterListData as it contains ALL items, not just selected ones
									const itemsFromCardFilter = originalCardFilter[cardType];
									const itemsFromEle = ele.items || ele.selectedItems;
									
									// Use the first available source that has items
									const items = (itemsFromCardFilter && Array.isArray(itemsFromCardFilter) && itemsFromCardFilter.length > 0)
										? itemsFromCardFilter
										: (itemsFromEle && Array.isArray(itemsFromEle) && itemsFromEle.length > 0)
											? itemsFromEle
											: [];
									
									// Only add if we found valid items
									if (Array.isArray(items) && items.length > 0) {
										expandedCardFilter[cardType] = items;
									}
								}
							}
						}
						
						// CRITICAL: If current card is in priorityData, add its filter from left sidebar (selectedItem)
						// This ensures the current card's filter is applied based on what's selected in the left sidebar
						if (currentCardIndex >= 0 && currentCardType) {
							// Get selected items from left sidebar (selectedItem state)
							// selectedItem contains the items selected in the ChartDialogLeftSidebar for the current card
							if (selectedItem && Array.isArray(selectedItem) && selectedItem.length > 0) {
								// Extract IDs from selectedItem (could be objects or strings)
								const selectedItemIds = selectedItem.map(item => {
									if (typeof item === 'object' && item !== null) {
										return item._id || item.id || item.key || item.name || item.label || item.value;
									}
									return item;
								}).filter(Boolean);
								
								if (selectedItemIds.length > 0) {
									// Use selected items from left sidebar for current card
									expandedCardFilter[currentCardType] = selectedItemIds;
								}
							} else {
								// Fallback: if selectedItem is empty, try to get from originalCardFilter
								// This handles the case where no items are selected (all items shown)
								const existingCurrentCardFilter = originalCardFilter[currentCardType];
								if (existingCurrentCardFilter && Array.isArray(existingCurrentCardFilter) && existingCurrentCardFilter.length > 0) {
									expandedCardFilter[currentCardType] = existingCurrentCardFilter;
								}
							}
						}
					};
					
					// CRITICAL: For admission page, process mainPriorityData first (it's primary)
					// Extract card types from mainPriorityData and ensure they exist as direct keys
					// Only process filters that come BEFORE current card in priority order
					const mainPriorityData = originalCardFilter.mainPriorityData || [];
					processPriorityData(mainPriorityData, true);
					
					// Extract card types from priorityData and ensure they exist as direct keys
					// Only process filters that come BEFORE current card in priority order
					const priorityData = originalCardFilter.priorityData || [];
					processPriorityData(priorityData, false);
					
					// CRITICAL: Trim mainPriorityData/priorityData arrays to include:
					// 1. Filters BEFORE current card (these are applied)
					// 2. Current card itself (so it gets processed, but uses selectedItem from left sidebar)
					// 3. Exclude filters AFTER current card (these should not be applied)
					// This ensures the analysis function respects priority order (same as hospital-common.js)
					// For admission page, mainPriorityData is primary
					if (Array.isArray(mainPriorityData) && mainPriorityData.length > 0 && currentCardType) {
						const currentCardIndex = mainPriorityData.findIndex((ele) => ele && ele.type === currentCardType);
						if (currentCardIndex >= 0) {
							// Include filters before current card AND current card itself
							// Filters after current card are excluded
							const trimmedMainPriorityData = mainPriorityData.slice(0, currentCardIndex + 1);
							// Update the current card entry to use selectedItem from left sidebar if available
							if (trimmedMainPriorityData.length > 0 && selectedItem && Array.isArray(selectedItem) && selectedItem.length > 0) {
								const currentCardEntry = trimmedMainPriorityData[trimmedMainPriorityData.length - 1];
								if (currentCardEntry && currentCardEntry.type === currentCardType) {
									// Extract IDs from selectedItem
									const selectedItemIds = selectedItem.map(item => {
										if (typeof item === 'object' && item !== null) {
											return item._id || item.id || item.key || item.name || item.label || item.value;
										}
										return item;
									}).filter(Boolean);
									
									if (selectedItemIds.length > 0) {
										// Update the entry to use selected items from left sidebar
										trimmedMainPriorityData[trimmedMainPriorityData.length - 1] = {
											...currentCardEntry,
											items: selectedItemIds,
											selectedItems: selectedItemIds,
										};
									}
								}
							}
							expandedCardFilter.mainPriorityData = trimmedMainPriorityData;
						} else {
							// Current card not in mainPriorityData, keep all filters
							expandedCardFilter.mainPriorityData = mainPriorityData;
						}
					} else if (Array.isArray(mainPriorityData) && mainPriorityData.length > 0) {
						// No current card type, keep all filters
						expandedCardFilter.mainPriorityData = mainPriorityData;
					}
					
					if (Array.isArray(priorityData) && priorityData.length > 0 && currentCardType) {
						const currentCardIndex = priorityData.findIndex((ele) => ele && ele.type === currentCardType);
						if (currentCardIndex >= 0) {
							// Include filters before current card AND current card itself
							const trimmedPriorityData = priorityData.slice(0, currentCardIndex + 1);
							// Update the current card entry to use selectedItem from left sidebar if available
							if (trimmedPriorityData.length > 0 && selectedItem && Array.isArray(selectedItem) && selectedItem.length > 0) {
								const currentCardEntry = trimmedPriorityData[trimmedPriorityData.length - 1];
								if (currentCardEntry && currentCardEntry.type === currentCardType) {
									const selectedItemIds = selectedItem.map(item => {
										if (typeof item === 'object' && item !== null) {
											return item._id || item.id || item.key || item.name || item.label || item.value;
										}
										return item;
									}).filter(Boolean);
									
									if (selectedItemIds.length > 0) {
										trimmedPriorityData[trimmedPriorityData.length - 1] = {
											...currentCardEntry,
											items: selectedItemIds,
											selectedItems: selectedItemIds,
										};
									}
								}
							}
							expandedCardFilter.priorityData = trimmedPriorityData;
						} else {
							// Current card not in priorityData, keep all filters
							expandedCardFilter.priorityData = priorityData;
						}
					} else if (Array.isArray(priorityData) && priorityData.length > 0) {
						// No current card type, keep all filters
						expandedCardFilter.priorityData = priorityData;
					}
					
					// CRITICAL: Always ensure current card's filter is in cardFilter when selectedItem is set
					// The current card's filter comes from selectedItem in the left sidebar (ChartDialogLeftSidebar)
					// This is needed for ALL cases:
					// 1. Current card is in priorityData/mainPriorityData - filter must be applied after filters before it
					// 2. Current card is NOT in priorityData/mainPriorityData - filter must still be applied (e.g., ninetyDaysData opened as current card)
					// This matches the behavior in hospital-common.js where the current card's filter is always applied
					if (currentCardType) {
						// Check if current card is in mainPriorityData or priorityData
						const isInMainPriorityData = Array.isArray(mainPriorityData) && mainPriorityData.some((ele) => ele && ele.type === currentCardType);
						const isInPriorityData = Array.isArray(priorityData) && priorityData.some((ele) => ele && ele.type === currentCardType);
						
						// CRITICAL: Always set the current card's filter from selectedItem (left sidebar)
						// This works for both cases: current card in priorityData/mainPriorityData and current card NOT in priorityData/mainPriorityData
						if (selectedItem && Array.isArray(selectedItem) && selectedItem.length > 0) {
							const selectedItemIds = selectedItem.map(item => {
								if (typeof item === 'object' && item !== null) {
									return item._id || item.id || item.key || item.name || item.label || item.value;
								}
								return item;
							}).filter(Boolean);
							
							if (selectedItemIds.length > 0) {
								// CRITICAL: Set the current card's filter in cardFilter
								// This ensures the filter from left sidebar is applied to the base card
								// This works for all card types (standard, custom, special filtering) and all pages
								expandedCardFilter[currentCardType] = selectedItemIds;
							}
						} else if (isInMainPriorityData || isInPriorityData) {
							// Fallback: if selectedItem is empty but current card is in priorityData/mainPriorityData, use existing filter if available
							const existingFilter = originalCardFilter[currentCardType];
							if (existingFilter && Array.isArray(existingFilter) && existingFilter.length > 0) {
								expandedCardFilter[currentCardType] = existingFilter;
							}
						}
					}
					
					trendDialogFilters = {
						...filters,
						cardFilter: expandedCardFilter,
						// Ensure patientListFromPage, dynamicCards, and ninetyDaysData are included
						patientListFromPage: filters?.patientListFromPage,
						dynamicCards: filters?.dynamicCards,
						ninetyDaysData: filters?.ninetyDaysData,
					};
				}

				// CRITICAL: Ensure ninetyDaysData is available in trendDialogFilters (applies to all filter modes)
				// It might not be in filters, so get it from multiple sources as fallback
				// This ensures the trend analysis can filter by ninetyDaysData even when it's not in the filters object
				if (!trendDialogFilters.ninetyDaysData || !Array.isArray(trendDialogFilters.ninetyDaysData) || trendDialogFilters.ninetyDaysData.length === 0) {
					// Try multiple sources in order of preference:
					// 1. Redux state patientList (most reliable - always has the full dataset)
					const state = store.getState();
					const patientListObj = state?.admission?.patientList || {};
					let ninetyDaysDataToAdd = patientListObj.ninetyDaysData;
					
					// 2. If not found, try filters.originalData (might have ninetyDaysData from API response)
					if ((!ninetyDaysDataToAdd || !Array.isArray(ninetyDaysDataToAdd) || ninetyDaysDataToAdd.length === 0) && filters?.originalData?.ninetyDaysData) {
						ninetyDaysDataToAdd = filters.originalData.ninetyDaysData;
					}
					
					// 3. If still not found, try chartData.originalData (might have it from the card data)
					if ((!ninetyDaysDataToAdd || !Array.isArray(ninetyDaysDataToAdd) || ninetyDaysDataToAdd.length === 0) && chartData?.originalData?.ninetyDaysData) {
						ninetyDaysDataToAdd = chartData.originalData.ninetyDaysData;
					}
					
					// Only add if we found valid data
					if (ninetyDaysDataToAdd && Array.isArray(ninetyDaysDataToAdd) && ninetyDaysDataToAdd.length > 0) {
						trendDialogFilters = {
							...trendDialogFilters,
							ninetyDaysData: ninetyDaysDataToAdd,
						};
					}
				}

				// CRITICAL: Choose the correct full unfiltered patient dataset:
				// - When filterMode === "removeAll", prefer the master patient list from Admission page
				//   (filters.patientListFromPage) so we completely ignore any card-level priority filters.
				// - When filterMode === "keepSome" BUT there are NO selectedFilterCards,
				//   treat it the same as "removeAll" (no filters kept) and use the master list as well.
				// - Otherwise, use defaultPatientData (full unfiltered dataset for this card)
				//   or fall back to chartData.mainData.
				const masterPatientListFromPage = Array.isArray(filters?.patientListFromPage)
					? filters.patientListFromPage
					: [];

				const hasSelectedFilterCards =
					Array.isArray(config?.selectedFilterCards) && config.selectedFilterCards.length > 0;

				// IMPORTANT: For accurate Trend Mapping, we should always start from the true
				// unfiltered master list when it's available (patientListFromPage), otherwise
				// filters applied in the main dialog would already be "baked into" defaultPatientData
				// and could not be turned off by Trend Mapping modes.
				const fullUnfilteredPatients =
					masterPatientListFromPage.length > 0
						? masterPatientListFromPage
						: (defaultPatientData.length > 0 ? defaultPatientData : chartData?.mainData || []);

				// Add census data to dialogFilters for accurate monthly calculations
				// This ensures chartGroupBy uses the same census values as the main chart
				trendDialogFilters = {
					...trendDialogFilters,
					censusAverage: censusAverage,
					censusByPeriod: censusByPeriod || [],
				};

				const result = await analyzeTrendsLocally({
					pageType: PAGE_TYPE.ADMISSION,
					dialogFilters: trendDialogFilters,
					config: trendConfigForAnalysis,
					baseCardType: filters?.type,
					patientsOverride: fullUnfilteredPatients,
					groupByType: buttonFilterType,
				});

				setTrendMappingResult(result);
				setIsTrendAnalyzing(false);

				dispatch({
					type: ADD_NOTIFICATION,
					payload: {
						id: "trendMappingCompletedAdmission",
						type: "success",
						label: "Trend analysis is completed. Matching patterns are available.",
					},
				});
			} catch (e) {
				console.error("Trend Mapping analysis failed", e);
				setIsTrendAnalyzing(false);
				dispatch({
					type: ADD_NOTIFICATION,
					payload: {
						id: "trendMappingFailedAdmission",
						type: "error",
						label: "Trend analysis failed. Please try again later.",
					},
				});
			}
		},
		[dispatch, filters, chartData, buttonFilterType, defaultPatientData, censusAverage, censusByPeriod, selectedItem]
	);

	const headerFilterOptions = () => {
		if(filters?.isTotalCard){
			return null;
		}
		return <Grid
			direction={"row"}
			justifyContent={"flex-start"}
			display={"flex"}
			justifyItems={"flex-start"}
			alignItems="center"
		>
			<Grid item>
				<AdmissionHeaderFilterList
					filterListData={filters?.filterListData}
					cardFilter={cardFilter}
					transferType={filters?.transferType}
					openFrom="detailView"
					percentageBy={percentageBy}
					lockedTotal={lockedTotal}
					lockedTotalBy={lockedTotalBy}
					lockeByADT={lockeByADT}
				/>
			</Grid>
		</Grid>
	}

	// Mobile sidebar toggle function
	const handleSidebarToggle = useCallback(() => {
		setIsSidebarExpanded(prev => !prev);
	}, []);

	const mainContentSx = {
		display: "flex",
		flexDirection: "column",
		flex: 1,
		minWidth: 0,
		minHeight: 0,
		height: "100%",
		transition: "all 0.3s ease-in-out",
		px: { xs: 0.75, sm: 3 },
		py: { xs: 0, sm: 2.5 },
		gap: { xs: 0.5, sm: 2 },
		...(isMobile && !isSidebarExpanded && { marginLeft: "4px" }),
		...(isMobile && {
			overflowY: "hidden",
		}),
	};

	const tableContentStackSx = {
		flex: 1,
		minHeight: 0,
		width: "100%",
		maxWidth: "100%",
		mt: { xs: 0, sm: 1 },
		overflow: "hidden",
		"& > *": {
			flex: 1,
			minWidth: 0,
			minHeight: 0,
			height: "100%",
		},
	};

	return (
		<ChartDialogContainer
			handleClose={handleClose}
			isOpen={isOpen}
			isMobile={isMobile}
			maxWidth={false}
			paperSx={
				isMobile
					? undefined
					: {
							width: "min(96vw, 1880px)",
							maxWidth: "min(96vw, 1880px)",
							margin: "16px auto",
						}
			}
		>
			{isMobile && !isSidebarExpanded && (
				<Grid
					item
					sx={{
						width: '4px',
						height: '100vh',
						backgroundColor: '#1976d2',
						transition: 'all 0.3s ease-in-out',
						position: 'relative',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						'&:hover': {
							width: '8px',
							backgroundColor: '#1565c0'
						}
					}}
				>
					<Box
						onClick={handleSidebarToggle}
						sx={{
							position: 'absolute',
							left: '250%',
							top: '10%',
							transform: 'translate(-50%, -50%)',
							backgroundColor: 'rgba(255, 255, 255, 0.9)',
							borderRadius: '50%',
							width: '20px',
							height: '20px',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							border: '1px solid rgba(0, 0, 0, 0.1)',
							boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
							cursor: 'pointer',
							zIndex: 1000,
							'&:hover': {
								backgroundColor: 'rgba(255, 255, 255, 1)',
								transform: 'translate(-50%, -50%) scale(1.1)'
							}
						}}
					>
						<KeyboardArrowRightIcon
							sx={{ fontSize: 12, color: '#1976d2' }}
						/>
					</Box>
				</Grid>
			)}
			{isMobile && (
				<ChartDialogLeftSidebar
					loading={loading}
					filterData={filterData}
					selectedItem={selectedItem}
					handleToggle={handleToggle}
					handleToggleAll={handleToggleAll}
					title={title}
					selectedTab={selectedTab}
					isFilterList={true}
					isExpanded={isSidebarExpanded}
					onToggleExpand={handleSidebarToggle}
					allowSpecialItemSelection={
						filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab &&
						filters?.question?.customTab?.isCustomDateAnalysis
					}
				/>
			)}
			{!isMobile && (
				<ChartDialogLeftSidebar
					loading={loading}
					filterData={filterData}
					selectedItem={selectedItem}
					handleToggle={handleToggle}
					handleToggleAll={handleToggleAll}
					title={title}
					selectedTab={selectedTab}
					isFilterList={true}
					isExpanded={isSidebarExpanded}
					onToggleExpand={handleSidebarToggle}
					allowSpecialItemSelection={
						filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab &&
						filters?.question?.customTab?.isCustomDateAnalysis
					}
				/>
			)}
			<Grid
				item
				xs={isMobile ? (isSidebarExpanded ? 7.5 : 11.8) : 10.7}
				sm={isMobile ? (isSidebarExpanded ? 7.5 : 11.8) : 10.7}
				sx={mainContentSx}
			>
				<ChartDetailsTab
					selectedTab={selectedTab}
					handleTabButton={handleTabButton}
					queryFilters={queryFilters}
					handleOnClickReport={onClickReport}
					handleOnClickShareReport={onClickShareReport}
					loading={loading}
					handleExcelReport={handleExcelReport}
					setSelectedFacility={setSelectedFacility}
					selectedFacility={selectedFacility}
					questions={questions}
					pageType={PAGE_TYPE.ADMISSION}
					filterHeaderContainer={() => headerFilterOptions()}
					tableFilterType={filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab ? "all" : null}
					isMobile={isMobile}
					onOpenTrendMapping={handleOpenTrendMapping}
				/>
				{selectedTab === CHART_TAB_BUTTON.TABLE && (
					<>
						<Divider sx={{ borderColor: "divider", opacity: 0.8 }} />
						<ChartDetailsSearchBar
							searchTerm={searchTerm}
							handleSearch={handleSearch}
							setSearchTerm={setSearchTerm}
							highlightedCount={debounceHighlightedCount}
							filterType={filterType}
							setFilterType={setFilterType}
							selectedHighlightedColumns={selectedHighlightedColumns}
							setSelectedHighlightedColumns={setSelectedHighlightedColumns}
							selectedQuestions={questions}
							isSelectColumn={filters?.question?.customTab?.type !== CUSTOM_TAB_TYPE.combineTab}
							selectedTab={selectedTab}
							isMobile={isMobile}
						/>
					</>
				)}
				{!loading && (
					<Box
						sx={{
							flex: 1,
							minHeight: 0,
							display: "flex",
							flexDirection: "column",
							overflow: selectedTab === CHART_TAB_BUTTON.TABLE ? "hidden" : "visible",
						}}
					>
					<NoteContainer page={PAGE_TYPE.ADMISSION} openFrom="dialog" isMobile={isMobile}>
						{selectedTab === CHART_TAB_BUTTON.BUILDING && (
							<Stack direction={"row"} sx={{ mt: 2, height: "99%" }}>
								<ChartBuildingList
									page={PAGE_TYPE.ADMISSION}
									data={chartData?.filterPatients || []}
									relation={filters?.relation}
									getFieldNames={getFieldNames}
									chartData={chartData}
									censusByFacility={censusByFacility}
									bedCapacityByFacility={bedCapacityByFacility}
									filterSelected={filters.filterSelected}
									filter={filters}
									buildingElementRef={buildingElementRef}
									dataComparison={chartDataComparison?.filterPatients || []}
									relationComparison={filtersComparison?.relation}
									chartDataComparison={chartDataComparison}
									censusByFacilityComparison={censusByFacilityComparison}
									bedCapacityByFacilityComparison={bedCapacityByFacilityComparison}
									filterSelectedComparison={filtersComparison?.filterSelected}
									filterComparison={filtersComparison}
									forAdmission={true}
									isTotalCard={filters?.isTotalCard}
									filterListData={filters?.filterListData}
									typeCard={filters?.type}
									isAdt={true}
									selectedADTTableData={filters?.selectedADTTableData}
								/>
							</Stack>
						)}
						{selectedTab === CHART_TAB_BUTTON.TABLE && (
							<Stack direction={"row"} sx={tableContentStackSx}>
								<ChartTableList
									data={chartData.filterPatients}
									relation={filters?.relation}
									getFieldNames={getFieldNames}
									tableElementRef={tableElementRef}
									pageType={PAGE_TYPE.ADMISSION}
									filters={filters}
									questions={questions}
									searchTerm={debouncedSearchTerm}
									handleHighlightedCount={handleHighlightedCount}
									highlightedCountDefaultValue={highlightedCountDefaultValue}
									filterType={filterType}
									selectedHighlightedColumns={selectedHighlightedColumns}
									isNotCombineTab={filters?.question?.customTab?.type !== CUSTOM_TAB_TYPE.combineTab}
									orderData={{
										orderBy,
										setOrderBy,
										order,
										setOrder
									}}
									activeFacilities={activeFacilities}
									tableFilterType={filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab ? "all" : null}
								/>
							</Stack>
						)}
						{selectedTab === CHART_TAB_BUTTON.CHART && (
							<Stack direction={"row"} sx={{ mt: isMobile ? 1 : 2, height: isMobile ? "auto" : "90%" }}>
								<CardDetailChart
									isChartArrow={!filters?.cardFilter?.ADTFilter}
									totalText="Total Admissions"
									data={(() => {
										const chartDataToUse = chartData.filterData || [];
										// ONLY clear facilityWiseData and facilityIds when:
										// 1. isCustomDateAnalysis is true
										// 2. An average filter (key/id/_id === "avarage" or "average") is selected
										// This ensures LineChartDialog uses pre-calculated average y values
										// For all other cases, use normal patient count logic
										if (
											filters?.question?.customTab?.isCustomDateAnalysis === true &&
											selectedTab === CHART_TAB_BUTTON.CHART
										) {
											const dataSource = filterData.length > 0 ? filterData : (customDataArrayRef.current || []);
											const selectedAverageItem = dataSource.find(
												(item) =>
													(selectedItem.includes(item._id || item.id || item.key) ||
														filters?.selectedFilterData?.includes(
															item._id || item.id || item.key
														)) &&
													isAverageItem(item)
											);

											// ONLY clear facilityWiseData/facilityIds if an average item is actually selected
											if (selectedAverageItem && isAverageItem(selectedAverageItem)) {
												// Clear facilityWiseData and facilityIds so LineChartDialog uses the y value directly
												// When both are empty/null, LineChartDialog should use ele.y directly
												return chartDataToUse.map(item => ({
													...item,
													facilityWiseData: null, // Clear to prevent recalculation
													facilityIds: [], // Clear to prevent facility counting
												}));
											}
										}
										return chartDataToUse;
									})()}
									filters={filters}
									handleChartLabelType={handleChartLabelType}
									censusAverage={censusAverage}
									total={(() => {
										const isCustomDateAnalysisCombineTab =
											filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab &&
											filters?.question?.customTab?.isCustomDateAnalysis;
										const patientCount = chartData.filterPatients.length || 0;
										
										// Display selectedAverageValue if an average item is selected, otherwise show patient count
										if (isCustomDateAnalysisCombineTab && selectedAverageValue !== null && !isNaN(selectedAverageValue)) {
											return selectedAverageValue;
										}
										return patientCount;
									})()}
									setQueryFilters={setQueryFilters}
									queryFilters={queryFilters}
									handleClickFilter={handleClickFilter}
									selectedFilter={selectedFilter}
									reloadChartData={reloadChartData}
									isChartTotalButton={isShowPercentage}
									selectedFacility={selectedFacility}
									dbData={dbData}
									isMobile={isMobile}
									onOpenTrendMapping={handleOpenTrendMapping}
								/>
							</Stack>
						)}
					</NoteContainer>
					</Box>
				)}
				<ChartTabLoader loading={loading} />
			</Grid>
			{/* Trend Mapping dialog */}
			<TrendMappingDialog
				open={isTrendMappingOpen}
				onClose={() => setIsTrendMappingOpen(false)}
				initialConfig={trendMappingConfig}
				pageType="ADMISSION"
				dialogFilters={filters}
				cardItemsMap={null}
				onAnalyze={handleAnalyzeTrendMapping}
				analyzing={isTrendAnalyzing}
				result={trendMappingResult}
				currentCardType={filters?.type}
				currentSelectedItems={selectedItem}
				currentCardChartData={chartData}
				currentFilterType={buttonFilterType}
			/>
		</ChartDialogContainer>
	);
}
